import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { useLookupsStore } from '../../stores/lookupsStore';
import LookupsWidget from '../../components/widgets/LookupsWidget';

const Lookups = () => {
  const { accessToken } = useAuthStore();
  const { tables, fetchTables, isLoading, error } = useLookupsStore();
  const [selectedTable, setSelectedTable] = useState(null);

  useEffect(() => {
    if (accessToken) {
      fetchTables(accessToken);
    }
  }, [accessToken, fetchTables]);

  if (isLoading && tables.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (error && tables.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="surface rounded-lg shadow-lg p-8 max-w-md w-full">
          <div className="text-center">
            <svg className="mx-auto h-12 w-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="mt-4 text-lg font-medium text-primary">Error Loading Lookups</h3>
            <p className="mt-2 text-sm text-secondary">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-primary mb-2">Lookup Tables Management</h1>
        <p className="text-secondary">Manage system lookup tables and their entries</p>
      </div>

      {/* Table Selection Grid */}
      {!selectedTable && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {tables.map((table) => (
            <button
              key={table.table}
              onClick={() => setSelectedTable(table.table)}
              className="surface border border-gray-200 dark:border-gray-700 rounded-lg p-6 text-left hover:shadow-lg transition-all hover:scale-105 cursor-pointer"
            >
              <h3 className="text-lg font-semibold text-primary mb-2">
                {table.label}
              </h3>
              <div className="flex gap-2 text-xs text-secondary">
                {table.has_profile_id && (
                  <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded">
                    User Entries
                  </span>
                )}
                {table.has_is_active && (
                  <span className="px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded">
                    Active Toggle
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      )}

      {/* Selected Table Widget */}
      {selectedTable && (
        <div>
          <button
            onClick={() => setSelectedTable(null)}
            className="mb-4 flex items-center gap-2 text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to all tables
          </button>

          <LookupsWidget tableName={selectedTable} />
        </div>
      )}
    </div>
  );
};

export default Lookups;
